import React, { useState, useEffect } from "react";
/* Components */
import Button from "../button/button";
import { Controller, useForm } from "react-hook-form";
//import { getInstitutions } from '../../services/institution';
import { useMutation } from "react-query";
import {
  authRegister,
  authLoginSocialMedia,
} from "../../services/auth.service";
import useSnackbarStore from "../../store/snackbarStore";
import { useMixPanel } from "../../hooks/useMixPanel";
import { useTranslation } from "react-i18next";
import { MIX_PANEL_EVENTS } from "../../utils/constans";
import countries from "../../config/countries/countries.json";
import useSessionStore from "../../store/useSessionStore";
import GoogleSign from "../google/GoogleSign";
import fetchCitiesByCountryCode from "../../services/geoname.service";
import ReactSelect from 'react-select';
import Popup from '../../components/popup/popup';
import Doodles from '../../assets/doodles.png';


const SignUpFormHubspot = ({ onSignIn }) => {
  const [loading, setLoading] = useState(false);
  const { show } = useSnackbarStore();
  const {
    control,
    register,
    handleSubmit,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      country: "",
      country_code: "",
      city: "",
    },
    mode: "onChange",
  });
  //const { data: institutions } = useQuery('institutions', getInstitutions, { refetchOnMount: false });
  const { setInitialEvent } = useMixPanel();
  const { t, i18n } = useTranslation();
  const [currentStep, setCurrentStep] = useState(1);
  const [cities, setCities] = useState([]);
  const selectedCountryCode = watch("country_code");
  const email = watch("email");
  const first_name = watch("first_name");
  const last_name = watch("last_name");
  const country = watch("country_code");
  const institution = watch("institution");
  const { setUser, setNewUserGoogle, setClearUserGoogle } = useSessionStore();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const nextStep = async () => {
    const dataLocalUser = {
      user: {
        email,
        first_name,
        last_name,
        country,
        institution,
      },
    };
    switch (currentStep) {
      case 1:
        setInitialEvent(dataLocalUser, MIX_PANEL_EVENTS.registerHBSStep1);
        break;
      case 2:
        setInitialEvent(dataLocalUser, MIX_PANEL_EVENTS.registerHBSStep2);
        break;
      case 3:
        setInitialEvent(dataLocalUser, MIX_PANEL_EVENTS.registerNativeStep3);
        break;
      default:
        break;
    }

    const stepFields = {
      1: ["terms", "data_processing"], // Asume estos campos para el paso 1
      2: ["first_name", "last_name", "email", "password"], // Asume estos campos para el paso 2
      3: ["institution", "country", "city"], // Asume estos campos para el paso 3
    };
    const currentFields = stepFields[currentStep];
    const result = await trigger(currentFields);
    if (result) {
      setCurrentStep(currentStep + 1);
    } else {
      console.error("Campos faltantes");
    }
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  useEffect(() => {
    if (selectedCountryCode) {
      const selectedCountry = countries.find(
        (country) => country.code === selectedCountryCode
      );
      const countryName = i18n.language === 'es' ? selectedCountry?.nombre : selectedCountry?.name;
      setValue("country", countryName || "");
      mutationCities.mutate(selectedCountryCode);
    }
    // eslint-disable-next-line
  }, [selectedCountryCode, setValue]);

  const onSubmit = (form) => {
    setLoading(true);
    mutation.mutate(form);
  };

  const mutation = useMutation(authRegister, {
    onSuccess: (data) => {
      setUser(data?.user);
      setInitialEvent(data, MIX_PANEL_EVENTS.registerHBS);
      show(t("usuario_registrado_mensaje_correo"),'success',10000);
      setLoading(false);
      setIsPopupOpen(!isPopupOpen);
    },
    onError: (error) => {
      if (error?.response.status === 401) {
        show(error.response.data.message, "error");
      }
      setLoading(false);
    },
  });

  const mutationSocialMedia = useMutation(authLoginSocialMedia, {
    onSuccess: (data) => {
      if (data?.user?.isNew) {
        setInitialEvent(data, MIX_PANEL_EVENTS.registerGoogleHBS);
        setNewUserGoogle(true);
        setIsPopupOpen(!isPopupOpen);
      } 
      setUser(data?.user);
      setLoading(false);
    },
    onError: (error) => {
      if (error?.response.status === 401) {
        show(error.response.data.message, "error");
      }
      setLoading(false);
      setClearUserGoogle();
    },
  });

  const mutationCities = useMutation(fetchCitiesByCountryCode, {
    onSuccess: (data) => {
      const formattedCities = data.map((e) => ({
        name: e.name,
      }));
      setCities(formattedCities);
    },
    onError: (error) => {},
  });

  const countryOptions = countries.map(country => ({
    value: country.code,
    label: i18n.language === 'es' ? country.nombre : country.name,
  }));
  
  const cityOptions = cities.map(city => ({
    value: city.name, 
    label: city.name,
  }));

  const SelectStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: 'rgb(38 38 38 / 0.13)',
      borderColor: 'transparent',
      borderRadius: '8px',
      caretColor: 'gary',
      '&:hover': { borderColor: 'transparent' } // Borde en hover
    }),
    input: (provided) => ({
      ...provided,
      color: '#262626',
      fontWeight: 'bold', // Establece el color del texto del input a blanco
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#F2F2F2' : '#FEFEFE',
      color: 'black',
      cursor: 'pointer',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: '#262626', // Color del indicador
      '&:hover': {
        color: '#3FB2E3', // Color del indicador en hover
      },
    }), 
    singleValue: (provided) => ({
      ...provided,
      color: '#262626', // Establece el color del texto de la opción seleccionada a blanco
      fontWeight: 'bold',
    }),
  };

  const onGoogleSuccess = (event) => {
    mutationSocialMedia.mutate({
      email: event?.email,
      first_name: event?.given_name,
      last_name: event?.family_name,
    });
  };

  const onGoogleError = (event) => {
    console.log("onGoogleError event ", event);
  };

  const handleRegister = () => {
    handleSubmit(onSubmit)();
  };

  return (
    <>
      <Popup isOpen={isPopupOpen} customClassName={'popup-hbs'}>
        <img src={Doodles} alt="Doodles" className="max-w-full w-80"/>
        <h4 className="text-shaiaBlue">{t('textoHBSConfirmacion1')}</h4>
        <p className="font-semibold text-4.5 text-center">{t('textoHBSConfirmacion2')}</p>
      </Popup>
      {!isPopupOpen && (
        <div className="flex flex-col gap-2 sm-max:order-2">
          <form onSubmit={handleSubmit(onSubmit)} className={`sign-up !bg-Grey-500 shadow-lg ${currentStep > 1 ? ' step-2-h' : ''}`}>
            <h2 className="alt-h1 w-full text-center">{t("register")}</h2>
            <div className="w-full flex-1">
              {/* Step 1 */}
              <div className={`${currentStep === 1 ? "flex" : "hidden"} flex-col`}>
                <div className="flex flex-col px-4 sm-max:px-2">
                  <h6 className="text-shaiaBlue text-center mb-4">{t('registroTextoBienvenida')}</h6>
                  <p className="text-DarkBlue-500 text-center">{t('registroTextoInstruccion')}</p>
                </div>
                <div className="flex flex-col items-center justify-center sm-max:gap-2 sm-max:pb-4">
                  <div className="sso-wrapper flex-1 md:max-w-1/2">
                    <GoogleSign onSuccess={onGoogleSuccess} onError={onGoogleError} />
                  </div>
                  <div className="login-divider w-[90%]">
                    <hr className="divider-hr bg-Grey-900"></hr>
                    <span className="text-Grey-900">o</span>
                    <hr className="divider-hr bg-Grey-900"></hr>
                  </div>
                  <Button
                    label={t('registroTextoBotonCorreo')}
                    variant="primary"
                    onClick={nextStep}
                    customClassName="!h-10 !py-3.5 flex-1 md:max-w-70/100"
                  />
                  <p className="text-DarkBlue-500 text-center px-4 sm-max:px-2 mb-0 mt-4">{t('aceptacionTerminos')}</p>
                  <div className="input-row mt-0 mb-6 px-3 gap-2">
                    <div className="input-text mt-2 flex-1">
                      <label
                        htmlFor="terms"
                        className="w-full flex flex-row justify-center gap-1 text-DarkBlue-500 text-3.5 font-bold"
                      >
                        <input
                          type="checkbox"
                          id="terms"
                          {...register("terms", { required: t("campo_requerido") })}
                        />
                        <span>
                          {t('acepatcionTerminos_check1')}
                          <a
                            href="https://www.mentu.la/tratamiento-de-datos"
                            className="underline text-shaiaBlue"
                          >
                            {t('acepatcionTerminos_check1a')}
                          </a>
                        </span>
                      </label>
                      {errors.terms && (
                        <span className="error">{errors.terms.message}</span>
                      )}
                    </div>
                    <div className="input-text mt-2 flex-1">
                      <label
                        htmlFor="data_processing"
                        className="w-full flex flex-row justify-center gap-1 text-DarkBlue-500 text-3.5 font-bold"
                      >
                        <input
                          type="checkbox"
                          id="data_processing"
                          {...register("data_processing", {
                            required: t("campo_requerido"),
                          })}
                        />
                        <span>
                        {t('acepatcionTerminos_check2')}
                          <a
                            href="https://www.mentu.la/autorizacion-de-tratamiento-de-datos"
                            className="underline text-shaiaBlue"
                          >
                          {t('acepatcionTerminos_check2a')}
                          </a>
                        </span>
                      </label>
                      {errors.data_processing && (
                        <span className="error">
                          {errors.data_processing.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* Step 2 */}
              <div className={`${currentStep === 2 ? "flex" : "hidden"} flex-col`}>
                <label className="input-label label-alt">
                  {t("registroNativoTitulo_step1")}
                </label>
                <div className="input-row">
                  <div className="input-text">
                    <label className="input-label text-DarkBlue-500">
                      {t("firstName")}(s):
                    </label>
                    <input
                      className="input-box bg-Grey-900/13 text-DarkBlue-500"
                      type="text"
                      {...register("first_name", {
                        required: t("requiredFirstName"),
                      })}
                    />
                    {errors.first_name && (
                      <span className="error">{errors.first_name.message}</span>
                    )}
                  </div>
                  <div className="input-text">
                    <label className="input-label text-DarkBlue-500">
                      {t("lastName")}(s):
                    </label>
                    <input
                      className="input-box bg-Grey-900/13 text-DarkBlue-500"
                      type="text"
                      {...register("last_name", {
                        required: t("requiredLastName"),
                      })}
                    />
                    {errors.last_name && (
                      <span className="error">{errors.last_name.message}</span>
                    )}
                  </div>
                </div>
                <div className="input-text mt-2">
                  <label className="input-label text-DarkBlue-500">{t("email")}:</label>
                  <input
                    className="input-box bg-Grey-900/13 text-DarkBlue-500"
                    type="email"
                    {...register("email", {
                      required: t("requiredEmail"),
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message: t("notValidEmail"),
                      },
                    })}
                  />
                  {errors.email && (
                    <span className="error">{errors.email.message}</span>
                  )}
                </div>
                <div className="input-text mt-2">
                  <label className="input-label text-DarkBlue-500">
                    {t("password")}:
                  </label>
                  <input
                    className="input-box bg-Grey-900/13 text-DarkBlue-500"
                    type="password"
                    {...register("password", { required: t("requiredPassword") })}
                  />
                  {errors.password && (
                    <span className="error">{errors.password.message}</span>
                  )}
                </div>
                <div className="input-text mt-2">
                  <label className="input-label text-DarkBlue-500">
                    {t("institution")}
                  </label>
                  <input
                    className="input-box bg-Grey-900/13 text-DarkBlue-500"
                    type="text"
                    {...register("institution", { required: t("campo_requerido") })}
                  />
                  {errors.institution && (
                    <span className="error">{errors.institution.message}</span>
                  )}
                </div>
                <div className="input-row">
                  <div className="input-text mt-2 flex-1">
                    {/* Selector de País */}
                    <label className="input-label text-DarkBlue-500">
                      {t("registro_qPais")}
                    </label>
                    <Controller
                      name="country_code"
                      control={control}
                      rules={{ required: t("campo_requerido") }}
                      render={({ field }) => (
                        <ReactSelect
                          {...field}
                          value={countryOptions.find(option => option.value === field.value)}
                          options={countryOptions}
                          placeholder={t("seleccionar_pais")}
                          onChange={(option) => {
                            if (typeof option === 'object' && option !== null) {
                              field.onChange(option.value);
                            }
                          }}
                          styles={SelectStyles}
                          isMulti={false}
                          maxMenuHeight={100}
                          menuPlacement='top'
                        />
                      )}
                    />
                    {errors.country_code && (
                      <span className="error">{errors.country_code.message}</span>
                    )}
                  </div>

                  <div className="input-text mt-2 flex-1">
                    {/* Selector de Ciudad */}
                    <label className="input-label text-DarkBlue-500">
                      {t("registro_qCiudad")}
                    </label>
                    <Controller
                      name="city"
                      control={control}
                      rules={{ required: t("campo_requerido") }}
                      render={({ field }) => (
                        <ReactSelect
                          {...field}
                          value={countryOptions.find(option => option.value === field.value)}
                          options={cityOptions}
                          placeholder={t("seleccionar_ciudad")}
                          onChange={option => field.onChange(option.value)}
                          styles={SelectStyles}
                          isMulti={false}
                          maxMenuHeight='100px'
                          menuPlacement='top'
                        />
                      )}
                    />
                    {errors.city && (
                      <span className="error">{errors.city.message}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div className="step-buttons">
            {currentStep > 1 && (
              <Button
                label="Anterior"
                variant="primary-outline"
                onClick={prevStep}
                customClassName="prev-btn"
              />
            )}
            {currentStep === 2 && (
              <Button
                label={loading ? t("creatingUser") : t("createUser")}
                variant="secondary"
                onClick={handleRegister}
                customClassName="sm-max:py-2.5"
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SignUpFormHubspot;
